import RunReport from './RunReport';
import './runReport.scss'

export default RunReport;